module.exports = __webpack_public_path__ + "img/techmoran-grey.1964784a.png";